// extracted by mini-css-extract-plugin
export default {"toast":"TokenPurchaseRoot_toast__mJkr4"};